/* eslint-disable max-len */
import { CustomTransformation } from '../types';

const CUSTOM_TRANSFORMATIONS: Array<CustomTransformation> = [
  {
    id: '1',
    name: 'Facebook Ad',
    thumbnailUrl: 'https://res.cloudinary.com/demo/image/upload/w_400,h_400,c_crop,g_face,r_max/w_200/lady.jpg',
    lastUsedAt: new Date('02/27/2020').toDateString(),
    presetTypes: ['image'],
    isInPresets: true,
    isAllowedForStrictTransformations: true,
    usageCount: 2786,
    transformationString: 'w_400,h_400,c_crop,g_face,r_max/w_200',
  },
  {
    id: '2',
    name: 'Facebook Cover',
    thumbnailUrl: 'https://res.cloudinary.com/cloudinary-mbryla/image/upload/v1583221493/image_eurnmp.png',
    lastUsedAt: null,
    presetTypes: ['video'],
    isInPresets: true,
    isAllowedForStrictTransformations: false,
    usageCount: 24,
    transformationString: '',
  },
  {
    id: '3',
    name: 'Instagram Ad',
    thumbnailUrl: 'https://res.cloudinary.com/demo/image/upload/l_text:Arial_100_bold:San%20Fransisco/l_text:Arial_100:%7C/cld-sample.jpeg',
    lastUsedAt: new Date('07/04/2020').toDateString(),
    presetTypes: ['image', 'video'],
    isInPresets: true,
    isAllowedForStrictTransformations: false,
    usageCount: 0,
    transformationString: 'l_text:Arial_100_bold:San%20Fransisco/l_text:Arial_100:%7C',
  },
  {
    id: '4',
    name: 'media_lib_thumb',
    thumbnailUrl: 'https://res-console-staging.cloudinary.com/demo/thumbnails/v1/image/upload/v1/c2FtcGxl/template_primary/Y19saW1pdCxoXzEwMCx3XzE1MA==',
    lastUsedAt: new Date('10/17/2019').toDateString(),
    isAllowedForStrictTransformations: true,
    transformationString: 'c_limit,h_100,w_150',
    isInPresets: false,
    presetTypes: [],
  },
  {
    id: '5',
    name: 'blog_cover',
    thumbnailUrl:
      'https://res-console-staging.cloudinary.com/demo/thumbnails/transform/v1/image/upload/Y19zY2FsZSxoXzIwMCxxXzk5LHJfMjgsd18yMDA=/v1/Y2xkLXNhbXBsZQ==/template_primary',
    lastUsedAt: new Date('10/17/2019').toDateString(),
    isAllowedForStrictTransformations: true,
    transformationString: 'c_scale,h_200,q_99,r_28,w_200',
    isInPresets: false,
    presetTypes: [],
  },
];

const duplicateTransformations = (amount: number) =>
  Array(amount)
    .fill(0)
    .map((record, index) => ({
      ...CUSTOM_TRANSFORMATIONS[index % CUSTOM_TRANSFORMATIONS.length],
      id: String(index),
    }));

const DUPLICATED_CUSTOM_TRANSFORMATIONS = duplicateTransformations(30);

export { DUPLICATED_CUSTOM_TRANSFORMATIONS as MOCKED_COOKBOOK_CUSTOM_TRANSFORMATIONS };
